import { useLocation } from 'react-router-dom';
import Customers from '../feature-module/frontend/Customer/customers';
import CustomerSidebar from '../feature-module/frontend/Customer/customerSidebar';
import { ProwlChatWidget } from '../feature-module/components/common/ui/ProwlChatWidget';
import CustomerHeader from '../feature-module/frontend/Customer/CustomerHeader';
import { ChatUnreadProvider } from '../context/ChatUnreadContext';

const CustomerLayout = () => {
  const location = useLocation();
  const isChatPage =
    location.pathname.includes('/customer-chat') ||
    location.pathname.includes('/customer/customer-chat');

  return (
    <ChatUnreadProvider>
      <div className="flex flex-row min-h-screen bg-[#FEFEFA] text-slate-800">
        <CustomerSidebar />
        <main className="main flex flex-col flex-grow laptop:ml-[260px] transition-all duration-150 ease-in overflow-x-hidden pt-16 sm:pt-16 laptop:pt-0">
          <CustomerHeader />
          <div className="main-content flex flex-col content-center flex-grow p-2 tablet:p-3 laptop:p-8 overflow-x-hidden pb-16">
            <div className="w-full">
              <Customers />
            </div>
          </div>
        </main>
        {!isChatPage && <ProwlChatWidget />}
      </div>
    </ChatUnreadProvider>
  );
};

export default CustomerLayout;
